import { render, staticRenderFns } from "./assessments-tabs.vue?vue&type=template&id=e4258cda&scoped=true"
import script from "./assessments-tabs.vue?vue&type=script&lang=js"
export * from "./assessments-tabs.vue?vue&type=script&lang=js"
import style0 from "./assessments-tabs.vue?vue&type=style&index=0&id=e4258cda&prod&scoped=true&lang=css"
import style1 from "./assessments-tabs.vue?vue&type=style&index=1&id=e4258cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4258cda",
  null
  
)

export default component.exports